import { NotProvisionedEmptyState } from 'ui/illustrations';
import styled from 'styled-components';
import { EmptyState } from 'ui/emptyState';
import { body1, colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { BrandAffinityBackground } from 'modules/intelligentInsights/brandAffinityInsights/components/layout/BrandAffinity.styles';
import { Link } from 'ui/links';
import {
  BRAND_AFFINITY_NOT_ENABLED,
  BRAND_AFFINITY_NOT_ENABLED_CONTACT_CSM,
  BRAND_AFFINITY_NOT_ENABLED_KNOWLEDGE_CENTER,
  BRAND_AFFINITY_NOT_ENABLED_LEARN_MORE,
} from 'modules/intelligentInsights/brandAffinityInsights/constants';

const Wrapper = styled.div`
  padding: ${spacing.x12} 0;
`;

const DescriptionWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  flex-direction: column;
  max-width: ${pxToRem(460)};
  margin: 0;
`;

const SubtitleText = styled.span`
  ${body1};
  margin: 0;
  color: ${colors.textSecondary};
`;

const StyledLearnMoreWrapper = styled.span`
  display: flex;
  gap: ${spacing.quarter};
`;

export const BrandAffinityNotEnabledId = 'brand-affinity-not-enabled';

export const BrandAffinityNotEnabled = () => (
  <BrandAffinityBackground>
    <Wrapper data-test={BrandAffinityNotEnabledId}>
      <EmptyState
        Illustration={NotProvisionedEmptyState}
        title={BRAND_AFFINITY_NOT_ENABLED}
        subtitle={
          <DescriptionWrapper>
            <SubtitleText>{BRAND_AFFINITY_NOT_ENABLED_CONTACT_CSM}</SubtitleText>
            <StyledLearnMoreWrapper>
              {BRAND_AFFINITY_NOT_ENABLED_LEARN_MORE}
              <Link
                size="body1"
                href="https://support.iterable.com/hc/en-us/articles/360052990191-Brand-Affinity"
              >
                {' '}
                {BRAND_AFFINITY_NOT_ENABLED_KNOWLEDGE_CENTER}
              </Link>
            </StyledLearnMoreWrapper>
          </DescriptionWrapper>
        }
      />
    </Wrapper>
  </BrandAffinityBackground>
);
